// extracted by mini-css-extract-plugin
export default {"modal__title":"AdvertisementFormModal_modal__title__N+GeN","modal__body":"AdvertisementFormModal_modal__body__8uc8i"};